export const BT_IN_MB = 1024 ** 2;

export const DEFAULT_SIZE_LIMIT_MB = 50;

export const ACCEPTED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif'];

export const ACCEPTED_IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
];

export const ACCEPTED_IMAGE_TYPES_ATTRIBUTE = ACCEPTED_IMAGE_EXTENSIONS.map(
  (extension) => `.${extension}`,
).join(', ');

export const isAcceptedImageFile = (file: File) => {
  if (file.type) {
    return ACCEPTED_IMAGE_MIME_TYPES.includes(file.type);
  }

  const extension = file.name.split('.').pop()?.toLowerCase();

  return !!extension && ACCEPTED_IMAGE_EXTENSIONS.includes(extension);
};
